import '../css-build/main.css';
import { Elm } from '../elm/LandingSite/Main.elm';

window.addEventListener('load', function() {
  const app = Elm.Main.init({
    node:
      document.getElementById('root') // no pre-rendered
      || document.getElementById('main'), // pre-rendered
    flags: {
      apiBaseUrlMap: process.env.API_BASE_URL_MAP,
      apiBaseUrl: process.env.API_BASE_URL_MAP.development,
      configAbiFiles: process.env.CONFIG_ABI_FILES,
      configurations: process.env.CONFIG_FILES,
      protoDocJson: process.env.SERVICE_CONFIG,
      path: window.location.href
    }
  });

  function findParent(tagname, el){
    if (!el) {
      return null;
    }

    if ((el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase()) {
      return el;
    }

    return findParent(tagname, el.parentNode);
  }

  document.addEventListener('click', (e) => {
    e = e || event;
    var from = findParent('a', e.target || e.srcElement);

    if (from && from.href && !from.rel && !e.metaKey) {
      history.pushState({}, '', from.href);
      e.preventDefault();
      app.ports.onUrlChange.send(from.href);
    }
  });

  // Inform app of browser navigation (the BACK and FORWARD buttons)
  window.addEventListener('popstate', () => {
    app.ports.onUrlChange.send(location.href);
  });

  app.ports.scrollIntoView.subscribe((elementId) => {
    let element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView();
    }
  });

  let postRender = window.requestAnimationFrame;

  app.ports.loadScript.subscribe(([id, src]) => {
    postRender(() => {
      var script = document.createElement('script');
      script.src = src;
      script.id = id;
      script.async = true;
      script.defer = true;
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  });

  app.ports.highlightScroll.subscribe(([navLinkSelector, sectionSelector]) => {
    postRender(() => {
      highlightScroll(navLinkSelector, sectionSelector);
    });
  });

  app.ports.pageTransition.subscribe(([from, to]) => {
    // Remove hire widgets when transitioning from about page
    if (from.toLowerCase() === '/about') {
      document.querySelectorAll('#hire_widget_iframe_0').forEach((el) => {
        el.parentElement.removeChild(el);
      });
    }
  });

});
